import { useState, useCallback } from 'react';
import quarkusApi from '../../../api/quarkusApi';

export function useDeleteConsultationType() {
  const [isDeleting, setDeleting] = useState(false);

  const remove = useCallback((consultationTypeId) => {
    setDeleting(true);
    return quarkusApi
      .delete(`/appointment-types/${consultationTypeId}`, {
        headers: { Authorization: sessionStorage.getItem('token') },
      })
      .finally(() => setDeleting(false));
  }, []);

  return { remove, isDeleting };
}
